import { fg } from '@atlaskit/platform-feature-flags';
import { getConfig } from '@atlassian/teams-common/context-config';

import RestClient from './rest-client';

const UNSHARDED_PREFIX = '/watermelon';

/**
 * @deprecated Use `TeamCentralRestClient` from `@atlassian/teams-app-internal-team-central` instead.
 */
export class TeamCentralRestClient extends RestClient {
	constructor() {
		super({ serviceUrl: getConfig().stargateRoot });
	}

	async hasWorkspaceForCloudId(cloudId: string): Promise<boolean> {
		try {
			await this.getResource(
				`${this.buildShardedPrefix(cloudId)}/workspace/exists?cloudId=${cloudId}`,
			);
			return true;
		} catch (err) {
			return false;
		}
	}

	async doesOrgContainAnyWorkspace(cloudId: string): Promise<boolean> {
		try {
			await this.getResource(
				(fg('enable_ptc_townsquare_reporting_lines_unsharded')
					? UNSHARDED_PREFIX
					: this.buildShardedPrefix(cloudId)) +
					`/organization/containsAnyWorkspace?cloudId=${cloudId}`,
			);
			return true;
		} catch (err) {
			return false;
		}
	}

	async isGlobalExperienceWorkspaceForCloudId(cloudId: string): Promise<boolean> {
		try {
			const res = await this.makeRequest(
				`${this.buildShardedPrefix(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`,
				{
					headers: {
						Accept: 'text/plain',
					},
				},
			);

			return Promise.resolve(res === 'GLOBAL_EXPERIENCE');
		} catch (err) {
			return Promise.resolve(false);
		}
	}

	private buildShardedPrefix(cloudId: string): string {
		return `/townsquare/s/${cloudId}`;
	}
}

/**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @deprecated Use the default export from `@atlassian/teams-app-internal-team-central/team-central-rest-client` instead.
 * @type {RestClient}
 */
// eslint-disable-next-line import/no-anonymous-default-export
const _default_1: TeamCentralRestClient = new TeamCentralRestClient();
export default _default_1;
